import AppRecord from './AppRecord.js'

class AssetClassGroup extends AppRecord {
  get long_name(){
    return this.name + ' (' + this.asset_class + ')'
  }
}
export default AssetClassGroup
